export default __webpack_public_path__ + "static/media/stage-3-substantianigra-amygdala.e1dc4142.png";